export default "__VITE_ASSET__DBVZBP$S__"